import api from "../utils/api"

const idaasConfig = {
  client_id: `${api[api.env].idaasClientId}`,
  response_type: "code",
  state: "dummydummy", // HACK
  scope: "openid offline profile national_id email phone address passport",
  prompt: "consent",
  access_type: "offline",
  usePkce: "false",
  redirect_uri: `${api[api.env].baseURL}/redirect/`,
  grant_type: "authorization_code",
  authorization_endpoint: `${api[api.env].idaasURL}/oauth2/authorize`,
  token_endpoint: `${api[api.env].idaasURL}/oauth2/token`,
  userinfo_endpoint: `${api[api.env].idaasURL}/userinfo`,
  tass_token_endpoint: `${api[api.env].taasTokenUrl}/token`,
  bau_token_endpoint: `${api[api.env].bauTokenUrl}/token`,
  auth_call: function () {
    const uri = `${this.authorization_endpoint}?client_id=${this.client_id}&response_type=${this.response_type}&state=${this.state}&scope=${this.scope}&prompt=${this.prompt}&access_type=${this.access_type}&usePkce=${this.usePkce}`
    return `${encodeURI(uri)}&redirect_uri=${encodeURIComponent(
      this.redirect_uri
    )}`
  },
  token_request_body: function () {
    return `redirect_uri=${this.redirect_uri}&grant_type=${this.grant_type}&client_id=${this.client_id}`
  },
}

export { idaasConfig }
